<template>
  <div class="sales" v-show="salePerson">
    <div>
      <b-card no-body class="h-100">
        <b-row class="sticky-top p-3">
          <b-col md="12">
            <header>
              <b-row class="mb-3 align-items-center">
                <b-col md="6">
                  <p class="mb-0"> <b>Assign Salesperson</b></p>
                </b-col>
                <b-col md="6">
                  <font-awesome-icon
                    @click="close()"
                    class="float-right"
                    :icon="['fas', 'times']"
                  />
                </b-col>
              </b-row>
            </header>
          </b-col>
          <b-col md="12">
            <b-input-group size="md" class="">
              <b-input-group-text slot="prepend" class="search-icon">
                <font-awesome-icon :icon="['fas', 'search']" />
              </b-input-group-text>
              <b-form-input
                placeholder="Search salesperson"
                class="search pl-0"
                autofocus
                id="search-salesperson"
                v-model="searchField"
                autocomplete="off"
                type="search"
                v-shortkey.focus="['ctrl', 'f']"
              ></b-form-input>
            </b-input-group>
          </b-col>
         
        </b-row>

        <div class="saleprsn">
           <hr class="mt-2" style="margin-bottom:-2px"/>
          
            <!-- <ul
              class="py-2 row list-inline align-items-center active"
              v-for="item in salesPersonsfilter"
              :key="item.index"
            >
              <li class="col-lg-2">
                <span>{{item.id}}</span>
              </li>
              <li class="col-lg-4">
                <span>{{item.firstname}} {{item.lastname}}</span>
              </li>
              <li class="col-lg-3">
                <button class="btn btn-secondary float-right">Assign to All</button>
              </li>
              <li class="col-lg-3">
                <button class="btn grey-outline-btn float-right">Not Assigned</button>
              </li>
            </ul>-->
            <b-table
              ref="selectedTable"
              selectable
              borderless
              select-mode="single"
              selected-variant="active"
              :items="salesPersonsData"
              :fields="field"
              @row-selected="selectedSalePersonDetails"
            >
              <!-- <template v-slot:cell(#)="data">{{ data.item.id }}</template> -->
              <template v-slot:cell(button)="data">
                <!-- <span>{{ data.rowSelected }}</span> -->
                <b-button
                  variant="primary"
                  class=""
                  v-if="data.rowSelected"
                  @click="assignToAll"
                  :disabled="state.billing.billing.cart.data == ''"
                  :id="'assign-to-all-' + data.item.id"
                >
                  <span v-if="$loading == false">Assign to All</span>
                  <b-spinner small v-if="$loading == true"></b-spinner>
                </b-button>

                <b-button
                  class="ml-2 mr-1"
                  :class="
                    data.item.product_list.length > 0
                      ? 'btn-danger'
                      : 'outline-secondary d-none'
                  "
                  :disabled="data.item.product_list.length == 0"
                  v-if="data.rowSelected"
                  @click="clearProduct(data.item.id)"
                  :id="'clear-' + data.item.id"
                >
                  <!-- <span
                    v-if="$loading == false"
                  ></span>-->
                  {{
                    data.item.product_list.length == 0
                      ? "Not Assigned"
                      : "Clear (" + data.item.product_list.length + ")"
                  }}
                  <!-- <b-spinner small v-if="$loading == true"></b-spinner> -->
                </b-button>
                 <b-button
                  v-if="!data.rowSelected"
                  class="assigned-badge ml-2 mr-1"
                  :variant="
                      data.item.product_list.length == 0 ? 'outline-secondary' : 'outline-secondary selected'
                    "
                    >{{
                      data.item.product_list.length == 0
                        ? "Not Assigned"
                        : "Assigned (" + data.item.product_list.length + ")"
                    }}</b-button>
              </template>
            </b-table>
          

          <b-row
            v-if="
              this.state.billing.billing.salesPerson.length == '' ||
                salesPersonsData == ''
            "
            class="notification align-items-center"
            style="height: 96%;"
          >
            <h6 class="text-center w-100">No Salesperson Found</h6>
          </b-row>
        </div>
      </b-card>
    </div>
    <!-- categories  listing-->
    <div class="clearfix"></div>
  </div>
</template>

<script>
//import carousel from "vue-owl-carousel";
import axios from "axios";
import { mapState } from "vuex";
import * as msg from "../message";

export default {
  name: "sales-person",
  //components: { carousel },
  props: {
    isDisplay: Boolean,
    isVisible: Boolean,
  },
  data() {
    return {
      salePerson: true,
      // isVisible: false,
      salesPersons: "",
      searchableName: true,
      searchField: "",
      selectedSalesPerson: "",
      selectSalesPerson: 0,
      field: [
        // { key: "#", label: "", class: "text-left align-middle pl-4 w-7" },
        { key: "firstname", label: "", class: "text-left align-middle" },
        { key: "button", label: "", class: "text-right" },
      ],
    };
  },
  mounted() {
    // this.fetchSalesPerson();
  },
  computed: {
    ...mapState({
      state: (state) => state,
      customerData() {
        return this.$store.getters["sessions/getCustomerParam"];
      },
      essentialsData() {
        return this.$store.getters["sessions/getEssentialsData"];
      },
      salesPersonsData() {
        let data = [];
        if (this.state.billing.billing.salesPerson.data.length > 0) {
          this.state.billing.billing.salesPerson.data.map((item) => {
            // console.log(item);
            let product_list = [];

            // Cart Product List Looping
            if (this.state.billing.billing.cart != "") {
              this.state.billing.billing.cart.data.map((carts) => {
                if (carts.salesman_id == item.salesman_id) {
                  product_list.push(carts.product_data.barcode);
                }
              });
            }

            data.push({
              id: item.salesman_id,
              firstname: item.first_name + " " + item.last_name,
              product_list: product_list,
              // lastname: item.last_name
            });
          });
        }
        if (!this.searchField) {
          return data;
        }
        const filterValue = this.searchField.toLowerCase();
        const filter = (event) =>
          event.id.toLowerCase().includes(filterValue) ||
          event.firstname.toLowerCase().includes(filterValue);

        return data.filter(filter);
      },
      salesPersonsfilter() {
        this.searchField = this.searchField.toLowerCase();
        return this.searchField
          ? this.salesPersonsData.filter((item) => {
              item.id.toLowerCase().includes(this.searchField) ||
                item.firstname.toLowerCase().includes(this.searchField);
            })
          : this.salesPersonsData;
      },
    }),
  },
  watch: {
    salesPersonsData: {
      handler(val) {
        if (this.$refs.selectedTable != undefined && this.isVisible == true) {
          this.$refs.selectedTable.items.map((item, index) => {
            if (item.id == this.state.billing.billing.salesPerson.selected.id) {
              this.$nextTick(() => {
                this.$refs.selectedTable.selectRow(index);
              });
              console.log("Ultra Cool");
            }
          });
        }
      },
      deep: true,
    },
    isVisible: function() {
      if (this.isVisible == false) {
        this.$nextTick(() => {
          this.$refs.selectedTable.clearSelected();
        });
        console.log("super cool");
      }
    },
  },
  methods: {
    close() {
      this.$emit("hide-salesp");
      this.$loading = false;
    },

    //  isRowSelected(data){
    //     if(data.id == this.salesPersonsData.id){
    //       this.assignPerson = true;
    //   }
    //   else{
    //     this.assignPerson = false;
    //   }
    // },
    // fetchSalesPerson() {
    //   this.$loading = false;
    //   let productData = {
    //     c_id: "",
    //     api_token: this.state.token,
    //     store_id: this.state.user.store_id,
    //     vu_id: this.state.user.id,
    //     trans_from: this.state.trans_from,
    //     udidtoken: this.state.trans_from
    //   };
    //   let data = Object.assign(productData, this.customerData);
    //   axios
    //     .post("/vendor/get-salesman", data)
    //     .then(response => {
    //       this.$loading = false;
    //       // this.salesPersons = response.data.data;
    //       this.$store.commit("salesPersons", response.data.data);
    //       this.state.billing.salesPerson.selected = "";
    //     })
    //     .catch();
    // },
    selectedSalePersonDetails(items) {
      if (items == "") {
        this.selectSalesPerson = 0;
        this.$emit("selected-sale-person", items);
      } else {
        // this.selectSalesPerson = items[0];
        this.state.billing.billing.salesPerson.selected = items[0];
        this.selectedSalesPerson = items[0];
        this.$emit("selected-sale-person", this.selectedSalesPerson);
      }
      // console.log(items);
    },
    clearProduct(data) {
      // console.log(data);
      // this.state.billing.salesPerson.data.map(item => {
      // console.log(item);
      // if (data == item.employee_code) {
      this.state.billing.billing.cart.data.map((item) => {
        if (item.salesman_id == data) {
          item.salesman_id = null;
        }
      });
      // }
      // });
      this.$loading = true;
      let postData = {
        // c_id: this.state.c_id,
        all: "",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        cart_id: "",
        trans_from: this.state.system.trans_from,
        salesman_id: this.selectedSalesPerson.id,
        // udidtoken: this.state.trans_from,
        check: "0",
        url: "/vendor/untag-salesman ",
      };
      let dataAxios = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(dataAxios.url, dataAxios)
        .then((response) => {
          // alert("1243");
          let alertData = {
            message: msg.SALESPERSON_UNTAGGED,
            type: "success",
          };
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", alertData);
          this.$store.dispatch("billing/cartDetails").then(() => {
            this.$loading = false;
          });
        })
        .catch((err) => {
          this.$loading = false;
        });
    },
    assignToAll() {
      this.state.billing.billing.cart.data.map((item) => {
        item.salesman_id = this.selectedSalesPerson.id;
      });
      this.$loading = true;
      let postData = {
        // c_id: this.state.c_id,
        all: "1",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        cart_id: "",
        trans_from: this.state.system.trans_from,
        salesman_id: this.selectedSalesPerson.id,
        // udidtoken: this.state.system.trans_from,
        check: "1",
        url: "/vendor/tag-salesman",
      };
      let dataAxios = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(dataAxios.url, dataAxios)
        .then((response) => {
          let alertData = {
            message: msg.SALESPERSON_TAGGED,
            type: "success",
          };
          this.$store.commit("notifications/showAlert", alertData);
          this.$store.dispatch("billing/cartDetails");
          this.$loading = false;
          this.$showAlert = true;
        })
        .catch((err) => {
          this.$loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.cat-listing {
  height: calc(100vh - 242px);
}
.cat-listing ul li a img {
  height: auto;
}

.theme-light .product-info span {
  color: #808080;
}

.product-catalog-wrapper .card .card-header {
  padding: 0;
  border: 0;
}
.dark-img,
.light-img {
  display: none;
}
.theme-light .light-img,
.theme-dark .dark-img {
  display: block;
}
.theme-light .dark-img,
.theme-dark .ligth-img {
  display: none;
}
// .product-catalog-wrapper .catalog-box {
//   background: #e8e8e8;
// }
.tabs {
  display: inline-flex;
  ul li a {
    padding: 0.7rem 1rem;
  }
}
.saleprsn {
  height: calc(100vh - 334px);
  overflow-y: auto;
  @include custom-scrollbar();
  overflow-x: hidden;
  ul:focus.active {
    background: #f0f0f0;
    border-left: 3px #4fb0ad solid;
  }
  ul {
    border-left: 3px #fff solid;
    cursor: pointer;
    &:focus,
    &:hover {
      background-color: #f0f0f0;
      border-left: 3px #4fb0ad solid;
    }
  }
}
.sales .tabs .card-header.tabs .card-header {
  width: 30% !important;
}
.product-catalog-wrapper .tabs .card-header .card-header-pills {
  display: flex;
}
.product-catalog-wrapper .tabs .card-header {
  border-bottom-left-radius: 5px !important;
}
// .grey-outline-btn {
//   border: 1px #c0c0c0 solid;
//   background-color: transparent !important;
//   color: #c0c0c0;
//   width: 120px;
// }
// .grey-outline-btn:focus:active {
//   border: 1px #e0e0e0 solid;
//   background-color: #e0e0e0 !important;
//   color: #fff;
// }
.saleprsn 
// .grey-outline-btn:hover {
//   border: 1px #c0c0c0 solid;
//   background-color: #c0c0c0 !important;
//   color: #fff;
// }

.theme-dark {
  .saleprsn {
    .table {
      color: $white-color !important;
    }
    ul {
      border-left: 3px #202020 solid;
      cursor: pointer;
      color: #c0c0c0;
      &:focus,
      &:hover {
        background-color: #303030;
        border-left: 3px #4fb0ad solid;
      }
    }
    .search-icon {
      background: #303030;
      border: none;
    }
  }
  input:focus {
    border: none !important;
  }
}

.search-icon {
  background: #f0f0f0 !important;
  border: none;
}
// input {
//   border-radius: 4px;
//   border: none;
//   background: #f0f0f0 !important;
// }
// input:focus {
//   border: none !important;
//   background: #f0f0f0 !important;
// }
.bg-white {
  background-color: $white-color;
}
.fa-times {
  cursor: pointer;
}
.sticky-top {
  z-index: 0;
}
.notification h6 {
  color: #c0c0c0 !important;
  font-size: 14px;
}
// .btn:hover {
//   color: #c0c0c0;
// }
.badge-pill {
  padding: 0.9em 1em;
  border-radius: 10rem;
}
.btn-outline-secondary:not(:disabled) {
  font-weight: 400;
  font-size: 12px;
  border-color: #e0e0e0;
  color:#e0e0e0 !important;
  &.selected{
    border-color: $theme-color;
    color: $theme-color !important;
    background-color: transparent;
  }
}
.theme-dark{
  .input-group-text {
    background: #303030 !important;
  }
  .btn-outline-secondary:not(:disabled){
    border-color: #393939;
     color:#393939 !important;
  }
}
</style>
